module.exports = __webpack_public_path__ + "static/img/litchi.9fccac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/litchi.jpg
// module id = R5Ed
// module chunks = 1